import KeywordHistoryChart from './KeywordHistoryChart.component';

export default KeywordHistoryChart;
